import React, { useEffect, useState } from "react";
import "../styles/projects.css";
import { popularProducts } from "../projectData.js";
import { techStack } from "../projTechList.js";
import ProjectThumbnail from "../components/ProjectThumbnail.jsx";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import DevList from "../components/ProjectComponents/DevList.jsx";
import UXList from "../components/ProjectComponents/UXList.jsx";

function Projects() {
  const [currentTab, setCurrentTab] = useState("dev");
  const projectsList = popularProducts.filter(
    (product) => product.type === "react",
  );

  const uxList = popularProducts.filter((product) => product.type === "ux");

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Project List",
    });
  }, []);

  const handleTabClick = (e) => {
    setCurrentTab(e.target.id);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: `About: ${e.target.id}`,
    });
  };

  return (
    <div className="projects-container flex fade">
      <div>
        <h2 className="d-block numbered-title text-dark">
          <span aria-hidden="true">/</span>Projects
        </h2>
      </div>

      <div className="tab-list underline-indicators fade ">
        <button
          key="dev"
          id="dev"
          aria-pressed={currentTab === "dev" ? "true" : "false"}
          className="aboutbutton uppercase text-dark letter-spacing-2 ff-sans-cond fs-400"
          onClick={handleTabClick}
        >
          Development
        </button>
        <button
          key="ux"
          id="ux"
          aria-pressed={currentTab === "ux" ? "true" : "false"}
          className="aboutbutton uppercase text-dark letter-spacing-2 ff-sans-cond fs-400 my-1"
          onClick={handleTabClick}
        >
          UX Design
        </button>
      </div>

      {currentTab === "dev" ? (
        <DevList projectsList={projectsList} />
      ) : (
        <UXList uxList={uxList} />
      )}
      <div className="flex f-center-vertical"></div>
    </div>
  );
}

export default Projects;
